<template>
  <div>
    <div v-show="!isLoading" class="intro-y flex items-center h-10 mt-10">
      <h2 class="text-lg font-medium">
        {{ offence.name }} Cases - {{ from }} to {{ to }} of {{ total }} case(s)
      </h2>
      <a
        href="#"
        class="text-lg ml-auto flex text-theme-1 dark:text-theme-10 items-center"
        @click="
          () => {
            this.$router.back();
          }
        "
      >
        <ArrowLeftCircleIcon class="w-4 h-4 mr-3" /> Back
      </a>
    </div>
    <div v-if="isLoading" class="text-center pt-16">
      <p class="text-3xl">Loading...</p>
    </div>
    <div v-if="!isLoading" class="grid grid-cols-12 gap-6 mt-5">
      <!-- BEGIN: Offence Cases -->
      <div
        v-for="(caseFile, key) in cases"
        :key="key"
        class="intro-y col-span-12 sm:col-span-6 xl:col-span-4"
      >
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center py-5 px-1">
            <div
              class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
            >
              <a
                :href="`${host_url}/cases/${caseFile.slug}`"
                class="font-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ caseFile.name }}
              </a>
              <div class="text-gray-600 text-sm">
                {{ caseFile.case_type.name }}
              </div>
              <div class="text-gray-600 text-xs">
                {{ caseFile.case_stage }}
              </div>
            </div>
            <div class="text-theme-9">
              <div class="w-24 py-1 px-2 text-center">
                {{
                  caseFile.duration_in_days > 0
                    ? caseFile.duration_in_days
                    : caseFile.duration_in_years > 0
                    ? caseFile.duration_in_years
                    : caseFile.duration_in_days
                }}
                {{
                  caseFile.duration_in_days > 0
                    ? "day(s)"
                    : caseFile.duration_in_years > 0
                    ? "year(s)"
                    : "day(s)"
                }}
              </div>
              <div class="text-center">
                {{ caseFile.case_status }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BEGIN: Users Layout -->
      <!-- BEGIN: Pagination -->
      <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center"
      >
        <ul class="pagination">
          <li>
            <button class="pagination__link" @click="gotoPage(1)">
              <ChevronsLeftIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="prevPage">
              <ChevronLeftIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="nextPage">
              <ChevronRightIcon class="w-4 h-4" />
            </button>
          </li>
          <li>
            <button class="pagination__link" @click="gotoPage(totalPages)">
              <ChevronsRightIcon class="w-4 h-4" />
            </button>
          </li>
        </ul>
      </div>
      <!-- END: Pagination -->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OffenceCases",
  data() {
    return {
      cases: [],
      offence: {},
      current_page: 1,
      page_size: 51,
      total: 0,
      totalPages: 0,
      from: 0,
      to: 0,
      isLoading: true,
      host_url: process.env.VUE_APP_CCD_CLIENT_URL
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getOffenceCases();
      }
    }
  },
  mounted() {
    this.getOffenceCases();
  },
  methods: {
    getOffenceCases() {
      axios
        .get(`${window.host}/api/offence-cases/${this.$route.params.id}`, {
          params: {
            ...this.filterParams,
            case_type: this.$route.params.id,
            page: this.current_page,
            page_size: this.page_size
          }
        })
        .then(response => {
          if (response.data) {
            this.cases = response.data.data.data;
            this.offence = response.data.offence;
            this.total = response.data.data.total;
            this.current_page = response.data.data.current_page;
            this.totalPages = response.data.data.last_page;
            this.from = response.data.data.from;
            this.to = response.data.data.to;
          }
          this.isLoading = false;
        });
    },
    gotoPage(index) {
      if (this.current_page == index) return;

      this.current_page = index;
      this.getOffenceCases();
    },
    nextPage() {
      if (this.current_page < this.totalPages) {
        this.current_page++;
        this.getOffenceCases();
      }
    },
    prevPage() {
      if (this.current_page > 1) {
        this.current_page--;
        this.getOffenceCases();
      }
    }
  }
};
</script>
